import { Head } from "@inertiajs/react"

import type {
  WorkOrderFilterOptions,
  WorkOrderFilters,
  WorkOrderRow,
} from "@/components/products/work_orders/types"
import { WorkOrderFilterBar } from "@/components/products/work_orders/work-order-filters"
import { WorkOrderHeader } from "@/components/products/work_orders/work-order-header"
import { WorkOrderTable } from "@/components/products/work_orders/work-order-table"
import { useOrgRoutes } from "@/hooks/use-org-routes"
import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface Props {
  work_orders: WorkOrderRow[]
  filters: WorkOrderFilters
  filter_options: WorkOrderFilterOptions
  counts: { open: number; closed: number; pending_review: number }
  can_edit: boolean
}

export default function WorkOrdersIndex({
  work_orders,
  filters,
  filter_options,
  counts,
}: Props) {
  const routes = useOrgRoutes()

  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Dashboard", href: routes.dashboardPath() },
    { title: "Work Orders", href: routes.workOrdersPath() },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Work Orders" />

      <div className="space-y-5 p-6">
        <WorkOrderHeader
          tablePath={routes.workOrdersPath()}
          boardPath={routes.workOrdersBoardPath()}
          view="table"
          pendingReview={counts.pending_review}
          inboxPath={routes.inboxPath()}
        />

        <WorkOrderFilterBar
          filters={filters}
          options={filter_options}
          path={routes.workOrdersPath()}
          counts={counts}
        />

        <WorkOrderTable
          workOrders={work_orders}
          filters={filters}
          path={routes.workOrdersPath()}
        />
      </div>
    </AppLayout>
  )
}
